import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
//import { HubAlertConfigDTO } from '../hub-alert-config/HubAlertConfigDTO.model';
import { AppConfig } from '../app.config';
import {environment} from '../../environments/environment';

@Injectable()
export class UserService {

    // url = "http://app.ccpdashboard.com:3400/api/"
   // url = AppConfig.settings.apiServer.webAPIURL;
    public baseurl: string = environment.base_url;
    constructor(private http: Http) { }


    GetAllUserProfiles(token: any, companyId: number): Observable<any> {
        const url = this.baseurl + 'api/User/GetAllUserProfiles?companyId=' + companyId;
        const bearer = 'Bearer ' + token.access_token;
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': bearer, 'CompanyId': companyId });
        const options = new RequestOptions({ headers: headers });
        return this.http.get(url, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    GetZendeskUrl(token: any, companyId: number): Observable<string> {
        const url = this.baseurl + 'api/User/GetZendeskUrl';
        const bearer = 'Bearer ' + token.access_token;
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': bearer, 'CompanyId': companyId });
        const options = new RequestOptions({ headers: headers });
        return this.http.get(url, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    GetUserInfo(userId: number, token: any, companyId: number): Observable<any> {
        const url = this.baseurl + 'api/User/GetUserProfileInfo?userId=' + userId;
        const bearer = 'Bearer ' + token.access_token;
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': bearer, 'CompanyId': companyId });
        const options = new RequestOptions({ headers: headers });
        return this.http.get(url, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    GetRoles(leveNumber: number, userId: number, token: any, companyId: number): Observable<any> {
        const url = this.baseurl + 'api/User/GetRoles?levelNumber=' + leveNumber + '&userId=' + userId;
        const bearer = 'Bearer ' + token.access_token;
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': bearer, 'CompanyId': companyId });
        const options = new RequestOptions({ headers: headers });
        return this.http.get(url, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    GetAllTimeZones(token: any, companyId: number): Observable<any> {
        const url = this.baseurl + 'api/User/GetAllTimeZones';
        const bearer = 'Bearer ' + token.access_token;
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': bearer, 'CompanyId': companyId });
        const options = new RequestOptions({ headers: headers });
        return this.http.get(url, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    DeleteUser(userId: number, token: any, companyId: number) {
        const url = this.baseurl + 'api/User/DeleteUser?userId=' + userId;
        const bearer = 'Bearer ' + token.access_token;
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': bearer, 'CompanyId': companyId });
        const options = new RequestOptions({ headers: headers });
        return this.http.get(url, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    CreateUser(user: any) {
        const url = this.baseurl + 'api/User/CreateUser';
        const body = JSON.stringify(user);
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const options = new RequestOptions({ headers: headers, method: 'post' });
        return this.http.post(url, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }


    FirstTimeUserLogged(userId: number, token: any) {
        const url = this.baseurl + 'api/User/FirstTimeUserLogged?userId=' + userId;
        const body = JSON.stringify('');
        const bearer = 'Bearer ' + token.access_token;
        const headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': bearer });
        const options = new RequestOptions({ headers: headers, method: 'post' });
        return this.http.post(url, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }


    GetLocationAlertNotifications(token: any, companyId: number, userName: string): Observable<any> {
        const url = this.baseurl + 'api/User/GetUserAlertConfiguration';
        const bearer = 'Bearer ' + token.access_token;
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': bearer, 'CompanyId': companyId, 'UserName': userName });
        const options = new RequestOptions({ headers: headers });
        return this.http.get(url, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    GetLevelAdminUserAlertConfiguration(token: any, companyId: number, userId: number): Observable<any> {
        const url = this.baseurl + 'api/User/GetLevelAdminUserAlertConfiguration?userId=' + userId + '&companyId=' + companyId;
        const bearer = 'Bearer ' + token.access_token;
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': bearer, 'CompanyId': companyId });
        const options = new RequestOptions({ headers: headers });
        return this.http.get(url, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    UpdateLocationAlertNotification(list: any, companyId: number, token: any, userName: string): Observable<any> {
        const url = this.baseurl + 'api/User/UpdateUserAlertConfig';
        const body = JSON.stringify(list);
        const bearer = 'Bearer ' + token.access_token;
        const headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': bearer, 'CompanyId': companyId, 'UserName': userName });
        const options = new RequestOptions({ headers: headers, method: 'post' });
        return this.http.post(url, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    UpdateLevelAdminLocationAlertConfiguration(list: any, userId: number, companyId: number, userName: string, token: any): Observable<any> {
        const url = this.baseurl + 'api/User/UpdateLevelAdminAlertConfig?userProfileId=' + userId + '&companyId=' + companyId + '&userName=' + userName;
        const body = JSON.stringify(list);
        const bearer = 'Bearer ' + token.access_token;
        const headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': bearer, 'CompanyId': companyId, 'UserName': userName });
        const options = new RequestOptions({ headers: headers, method: 'post' });
        return this.http.post(url, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    SendVerificationLink(email: string): Observable<any> {
        const url = this.baseurl + 'api/User/ForgotPassword?email=' + email;
        const body = JSON.stringify('');
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const options = new RequestOptions({ headers: headers, method: 'post' });
        return this.http.post(url, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    // GetHubAlertNotifications(token: any, companyId: number, userId: number): Observable<HubAlertConfigDTO> {
    //     var url = this.baseurl+'api/User/GetHubAlertConfiguration';
    //     var bearer = 'Bearer ' + token.access_token;
    //     let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': bearer, 'CompanyId': companyId, 'userId': userId });
    //     let options = new RequestOptions({ headers: headers });
    //     return this.http.get(url, options)
    //         .map(this.extractData)
    //         .catch(this.handleError);
    // }

    // UpdateHubAlertNotifications(token: any, hubAlertConfig: HubAlertConfigDTO, companyId: number, userName: string): Observable<any> {
    //     var url = this.baseurl+'api/User/UpdateHubAlertConfiguration';
    //     let body = JSON.stringify(hubAlertConfig);
    //     var bearer = 'Bearer ' + token.access_token;
    //     let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': bearer, 'CompanyId': companyId, 'UserName': userName });
    //     let options = new RequestOptions({ headers: headers, method: "post" });
    //     return this.http.post(url, body, options)
    //         .map(this.extractData)
    //         .catch(this.handleError);
    // }

    ChangePassword(userId: number, newPassword: string, oldPassword: string, token: any, companyId) {
        const url = this.baseurl + 'api/User/ChangePassword?userId=' + userId + '&currentPassword=' + oldPassword + '&newPassword=' + newPassword;
        const bearer = 'Bearer ' + token.access_token;
        const headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': bearer, 'CompanyId': companyId });
        const body = JSON.stringify('');
        const options = new RequestOptions({ headers: headers, method: 'post' });
        return this.http.post(url, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

  verifyAccount(userId: string, code: string, newPassword: string) {
    const url = this.baseurl + 'api/User/SetNewPassword';
    const headers = new Headers({ 'Content-Type': 'application/json', 'userId': userId, 'code': code, 'password': newPassword });
    const body = JSON.stringify('');
    const options = new RequestOptions({ headers: headers, method: 'post' });
    return this.http.post(url, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }
  
    ResetPassword(userId: string, code: string, newPassword: string, email: string) {
        const url = this.baseurl + 'api/User/ResetPassword';
        const headers = new Headers({ 'Content-Type': 'application/json', 'userId': userId, 'code': code, 'password': newPassword, 'email': email });
        const body = JSON.stringify('');
        const options = new RequestOptions({ headers: headers, method: 'post' });
        return this.http.post(url, body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    private extractData(res: Response) {
        const body = res.json();
        return body || {};
    }
    private handleError(error: Response | any) {
        // In a real world app, you might use a remote logging infrastructure
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        // console.error(errMsg);
        return Observable.throw(errMsg);
    }

}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/Services/user.service.ts